// extracted by mini-css-extract-plugin
module.exports = {"container":"product-listings-module--container--HVUpO","heading":"product-listings-module--heading--3xwyJ"};